var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.121 15.664 7.933 7.933c1.414 1.414-.707 3.535-2.121 2.12L16 17.786l-7.933 7.933c-1.414 1.414-3.535-.707-2.121-2.121l7.933-7.933-7.666-7.666c-1.415-1.414.707-3.536 2.121-2.121L16 13.543l7.666-7.666c1.414-1.415 3.536.707 2.121 2.12l-7.666 7.667z"
})));

export default SvgCross;